import api from './api';

export const getMonthlyRpt = (queryParams) => {
  const { userType, theYear } = queryParams;
  return api.get(`/api/admin/monthlyReport?userType=${userType}&year=${theYear}`)
    .then(r => r.data)
    .catch(error => {
      console.error('Get monthly report error:', error);
      throw error;
    });
};

export const getAnalyticsSummary = (period) =>
  api.get(`/api/admin/analytics/summary?period=${period}`)
    .then(r => {
      // API returns { message: "...", data: {...actual data...} }
      // Extract the inner data object
      return r.data && r.data.data ? r.data.data : r.data;
    })
    .catch(error => {
      console.error('Get analytics summary error:', error);
      throw error;
    });

export const refreshAnalytics = (period) =>
  api.post('/api/admin/analytics/refresh', { period })
    .then(r => {
      // API returns { message: "...", data: {...actual data...} }
      return r.data && r.data.data ? r.data.data : r.data;
    })
    .catch(error => {
      console.error('Refresh analytics error:', error);
      throw error;
    });

export const getAnalyticsJob = (jobId) =>
  api.get(`/api/admin/analytics/jobs/${encodeURIComponent(jobId)}`)
    .then(r => {
      // API returns { message: "...", data: {...actual data...} }
      return r.data && r.data.data ? r.data.data : r.data;
    })
    .catch(error => {
      console.error('Get analytics job error:', error);
      throw error;
    });

export const getReports = (params) =>
  api.post('/api/admin/getreports', params)
    .then(r => r.data)
    .catch(error => {
      console.error('Get reports error:', error);
      throw error;
    });

export const generateReport = (reportType, params) =>
  api.post('/api/admin/generatereport', { reportType, ...params })
    .then(r => r.data)
    .catch(error => {
      console.error('Generate report error:', error);
      throw error;
    });

export const exportReport = (reportId, format) =>
  api.post('/api/admin/exportreport', { reportId, format }, { responseType: 'blob' })
    .then(r => r.data)
    .catch(error => {
      console.error('Export report error:', error);
      throw error;
    });

export const getAnalyticsSnapshot = (shortId) =>
  api.get(`/api/admin/analytics/snapshot/${encodeURIComponent(shortId)}`)
    .then(r => r.data)
    .catch(error => {
      console.error('Get analytics snapshot error:', error);
      throw error;
    });

export const getAnalyticsHealth = () =>
  api.get('/api/admin/analytics/health')
    .then(r => r.data)
    .catch(error => {
      console.error('Get analytics health error:', error);
      throw error;
    });
